import React, { useEffect, useState } from "react";
import { any, reject, mapObjIndexed, values } from "ramda";
import { useMutation } from "@apollo/client";

import Field from "./Field";
import * as UI from "./ui";
import { isBlank, isPresent } from "../../lib/presence";
import { combineValidations, presence, formatOf } from "../../lib/validations";
import { loginToGuestSessionMutation } from "./queries";

const validations = {
  otp: combineValidations([
    presence,
    formatOf({ pattern: /^[A-Fa-f0-9]{6}$/, message: "Must be 6 characters" }),
  ]),
}

const validate = (values, validations) =>
  reject(isBlank,
    mapObjIndexed((validation, id) =>
      validation && validation(values[id], values), validations)
  )
  
const OtpForm = ({ setAuthToken, setMode }) => {
  const [otp, setOtp] = useState("");
  const [formErrors, setFormErrors] = useState({});
  const [showAllErrors, setShowAllErrors] = useState(false);
  const [loginToGuestSession, { loading }] = useMutation(loginToGuestSessionMutation);

  const validateForm = () => { setFormErrors(validate({ otp }, validations)) }

  useEffect(validateForm, [otp]);

  const onSubmit = e => {
    e.preventDefault();

    if (any(isPresent, values(formErrors))) {
      setShowAllErrors(true)
      return;
    }

    loginToGuestSession({ variables: { otp } }).then(
      ({ data }) => {
        if (data.loginToGuestSession.error) {
          setMode("email");
        } else {
          const session = data.loginToGuestSession.guestSession;
          setAuthToken(session.authToken);
          setMode("entry");
        }
      }
    );
  };

  return (
    <React.Fragment>
      <UI.Header>
        <UI.Heading>View Your Entries</UI.Heading>
        <UI.Subheading>Your one-time passcode (OTP) will be in your email inbox</UI.Subheading>
        <UI.Notice>If you have entered the sweepstakes with this email, we will send you a one-time password to access a list of your entries.</UI.Notice>
      </UI.Header>
      <UI.FormWrapper>
        <UI.Form onSubmit={onSubmit}>
          <Field id="otp" label="Verification Code" type="text" onChange={e => setOtp(e.target.value)} value={otp} errors={formErrors.otp} touched={showAllErrors} required={true} maxLength={6} />
          <UI.FieldGroup>
            <UI.ActionButton value="Submit" disabled={loading} />
          </UI.FieldGroup>
        </UI.Form>
      </UI.FormWrapper>
    </React.Fragment>
  );
};

export default OtpForm;
